import { useAsyncGenericChannelsWithCapabilities } from 'composer-data/channel-capabilities/public/hooks';
export const useGetChannelName = genericChannelId => {
  const {
    data
  } = useAsyncGenericChannelsWithCapabilities();
  const genericChannel = data && data[genericChannelId];
  return genericChannel ? genericChannel.displayName : '';
};